module.exports = __webpack_public_path__ + "img/index.917b6d77.jpg";